import { EventCompletionStatus } from 'src/graphql/_generated';
import * as Yup from 'yup';

export const validationSchema = Yup.object({
  actions: Yup.array().of(
    Yup.object({
      notes: Yup.string().required('Required'),
      assignedTo: Yup.object()
        .test('required', 'Required', (value: any) => {
          return value && (value.text || value.email);
        })
        .nullable()
        .required('Required'),
      dueDate: Yup.string().required('Required'),
      completedAt: Yup.string()
        .nullable()
        .when('completionStatus', {
          is: EventCompletionStatus.Done,
          then: (schema) => schema.required('Required'),
          otherwise: (schema) => schema.nullable(),
        }),
    }),
  ),
});
